export default function getWasteDocumentDetailFields($t) {
  return [
    {
      name: 'name',
      is_visible: true,
      get short_title() {
        return $t('Waste.Waste')
      },
      get title() {
        return $t('Waste.Waste')
      }
    },
    {
      name: 'quantity',
      is_visible: true,
      get short_title() {
        return $t('Waste.detail_TableColumn_Quantity')
      },
      get title() {
        return $t('Waste.detail_TableColumn_Quantity')
      }
    },
    {
      name: 'unitName',
      type: 'portal',
      is_visible: true,
      get short_title() {
        return $t('Waste.detail_TableColumn_UnitCode')
      },
      get title() {
        return $t('Waste.detail_TableColumn_UnitCode')
      }
    },
    {
      name: 'baseQuantity',
      type: 'quantity',
      is_visible: true,
      get short_title() {
        return $t('Waste.detail_TableColumn_BaseQuantity')
      },
      get title() {
        return $t('Waste.detail_TableColumn_BaseQuantity')
      }
    },
    {
      name: 'baseUnitName',
      type: 'portal',
      is_visible: true,
      get short_title() {
        return $t('Waste.detail_TableColumn_BaseUnit')
      },
      get title() {
        return $t('Waste.detail_TableColumn_BaseUnit')
      }
    },
    {
      name: 'totalCost',
      type: 'currency',
      is_visible: true,
      get short_title() {
        return $t('Waste.detail_TableColumn_Price')
      },
      get title() {
        return $t('Waste.detail_TableColumn_Price')
      }
    }
  ]
}
